import React from 'react'
import { ButtonType } from 'foundations-library/types'
import { Button, Infotip } from 'foundations-library/components'
import { pendingStatuses } from '../utils/statuses'

type PropsType = {
    status: string
} & ButtonType

/**
 *
 */
const EditButton = ({ status, ...props }: PropsType): JSX.Element => {
    if (!status) return <></>

    const disabled = pendingStatuses.includes(status)
    return <div>
        <Infotip
            bottom
            value={
                disabled
                    ? "This Brand or Campaign can't be edited while under review or once approved"
                    : ''
            }
        >
            <Button disabled={disabled} variant='outlined' {...props}>Edit</Button>
        </Infotip>
    </div>
}

export default EditButton
